import moment from 'moment';
import { calculateCarTax, taxRenewalPeriod } from '@shared/car-tax';
import { hasAutomaticTaxRule } from '@shared/car-tax/baseTax';

// Vue 2 adapter between a document Detail page (this.form, this.car_tax, ...) and
// the framework-free tax rules in shared/car-tax. It only reads page state and
// writes the result back; every rule lives in shared/.
export default {
  computed: {
    requiresManualTax() {
      return Boolean(this.form.car_type) && !hasAutomaticTaxRule(this.form.car_type);
    },
    // Buddhist-era year the renewed tax runs to, or null before a valid renewal.
    taxRenewalEndYear() {
      const endYear = taxRenewalPeriod(this.carTaxRenewalState()).endYear;
      return endYear > 0 ? endYear + 543 : null;
    },
    taxRenewalYearCount() {
      return taxRenewalPeriod(this.carTaxRenewalState()).yearCount;
    },
    // Car's age in whole years at the time of filing (car_tax.car_age is months).
    carAgeYears() {
      return Math.floor(Number(this.car_tax.car_age) / 12);
    },
    // Which numbered year of ownership this renewal is for (age 5 years -> year 6).
    taxRenewalYearNumber() {
      return this.carAgeYears + 1;
    },
    // Every ownership year this renewal covers, e.g. [8, 9, 10] when 3 years'
    // back tax are owed, or just [6] for a normal, on-time renewal.
    taxRenewalYears() {
      const count = Math.max(this.taxRenewalYearCount, 1);
      const end = this.taxRenewalYearNumber;
      const years = [];
      for (let y = end - count + 1; y <= end; y++) years.push(y);
      return years;
    }
  },
  methods: {
    carTaxInput() {
      return {
        carType: this.form.car_type,
        carWeight: this.form.car_weight,
        engineSize: this.form.engine_size,
        carFuel: this.form.car_fuel,
        extraFuel: this.form.extra_fuel,
        isCorporationCar: this.form.is_corporation_car,
        registrationDate: this.form.registration_date,
        taxoutDate: this.form.taxout_date,
        billTaxoutDate: this.form.bill_taxout_date,
        taxFillingDate: this.form.tax_filling_date,
        isActiveTaxYearEnd: this.isActiveTaxYearEnd,
        isActiveTaxYearInit: this.isActiveTaxYearInit,
        dialogYearChoose: this.dialogYearChoose,
        carTaxScrap: this.list.setting.car_tax_scrap
      };
    },

    carTaxRenewalState() {
      return {
        isActiveTaxYearEnd: this.isActiveTaxYearEnd,
        totalTaxPrice: this.car_tax.total_tax_price,
        lateAge: this.car_tax.late_age
      };
    },

    async main_calculate() {
      const result = calculateCarTax(this.carTaxInput(), { moment: moment });
      this.car_tax.net_tax_price = result.netTaxPrice;
      this.car_tax.total_tax_price = result.totalTaxPrice;
      this.car_tax.tax_price = result.taxPrice;
      this.car_tax.tax_by_year = result.taxByYear;
      this.car_tax.popup_massage = result.popupMessages;
      this.car_tax.late_age = result.lateAge;
      this.car_tax.car_age = result.carAge;
      this.car_tax.tax_year_init = result.taxYearInit;
      this.car_tax.tax_year_ended = result.taxYearEnded;
      this.total_tax = result.totalTax;
      this.tax_penalty = result.taxPenalty;
      this.isActiveTaxYearEnd = result.isActiveTaxYearEnd;
      this.isActiveTaxYearInit = result.isActiveTaxYearInit;
    },

    // Stores the renewal period in the document so invoices and receipts show
    // what was quoted instead of recomputing it from today's date.
    syncTaxRenewalYearToForm() {
      const period = taxRenewalPeriod(this.carTaxRenewalState());
      this.form.tax_renewal_end_year = period.endYear;
      this.form.tax_renewal_year_count = period.yearCount;
    }
  }
};
